import { releaseBookingReservation } from 'api/experiences'
import { reportClientError } from 'services/errorReportingService'

export function releaseExperienceReservationOnItemRemove(
  item: App.Checkout.AnyItem | undefined,
  itemId: string,
): void {
  const providerBookingData = item?.itemType === 'experience' && item.metaData?.providerBookingData
  const reservationToken = providerBookingData && typeof providerBookingData === 'object' &&
    typeof (providerBookingData as Record<string, unknown>).reservationToken === 'string'
    ? (providerBookingData as Record<string, string>).reservationToken
    : undefined
  const reservationExpiresAt = providerBookingData && typeof providerBookingData === 'object' &&
    typeof (providerBookingData as Record<string, unknown>).reservationExpiresAt === 'string'
    ? (providerBookingData as Record<string, string>).reservationExpiresAt
    : undefined
  const isExpired = reservationExpiresAt ? Date.parse(reservationExpiresAt) <= Date.now() : false

  if (reservationToken && item?.itemType === 'experience' && !isExpired) {
    releaseBookingReservation(item.experienceId, reservationToken).catch(error => {
      reportClientError(error, { context: 'release_experience_reservation', itemId })
    })
  }
}
